import axiosConfig from './axiosConfig';

const apiCountry = {
   list: (filter) => axiosConfig.requests.get(`/country?PageNumber=${filter.pageNumber}&PageSize=${filter.pageSize}`),
};

export default { apiCountry };
